/**
 * Copyright 2021 AEKI <admin@aeki.dev>
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
import { style } from 'typestyle'

/* Styles ======================================================================================= */
import { StyleClass } from '../style-class'

/* Types ======================================================================================== */
import { ComponentBaselineType } from '../__core/component.types'

type ClassNames = {
  /**
   * Base class for text field
   */
  base: string
  /**
   * Themed class for text field
   */
  themed: string
  /**
   * Proped class for text field
   */
  proped: {
    focused: string
  }
}

type ClassProps = {
  baseline: ComponentBaselineType
  freeSize?: boolean
}

const getNames: (props: ClassProps, theme: any) => ClassNames = (props, theme) => {
  const { baseline } = props
  const base = style({
    // background: theme.getBaseline(baseline).color.medium,
    cursor: 'text',
    flexWrap: 'wrap',
    outline: 'none',
    padding: props.freeSize ? '4px' : '0 8px',
    fontSize: 16,
    borderRadius: 4,
    letterSpacing: 0,
    width: '100%',
    $nest: {
      '& input': {
        // width: '100%',
        flex: 1,
        // width: 'fit-content',
        height: '100%',
        background: 'none',
        border: 'none',
        outline: 'none',
        margin: props.freeSize ? '4px' : '',
      },
    },
  })

  const themed = style({
    background: theme.getBaseline(baseline).color.medium,
    $nest: {
      '*': {
        // background: theme.getBaseline(baseline).color.medium,
        color: theme.getBaseline(baseline).contrast.medium,
      },
    },
  })

  const proped = {
    focused: style({
      // background: theme.getBaseline('background').color.dark,
    }),
  }

  return {
    base,
    themed,
    proped,
  }
}

/* Export ======================================================================================= */
export const textFieldClass = new StyleClass<ClassNames, ClassProps>(getNames)
